import { StateCreator } from "zustand";
import { RootState } from "store";

export type NotificationType = "success" | "error" | "warning" | "info";

export interface ToastNotification {
  id: string;
  type: NotificationType;
  message: string;
}

export interface ToastNotificationSlice {
  data: ToastNotification[];
  addNotification: (type: NotificationType, message: string) => void;
  removeNotification: (id: string) => void;
  clearNotifications: () => void;
}

export const createToastNotificationSlice: StateCreator<
  RootState,
  [["zustand/devtools", never]],
  [],
  ToastNotificationSlice
> = (set, get) => ({
  data: [],

  addNotification: (type, message) => {
    const id = crypto.randomUUID();
    const newNotification: ToastNotification = { id, type, message };

    set(
      (state) => ({
        toastNotifications: {
          ...state.toastNotifications,
          data: [...state.toastNotifications.data, newNotification]
        }
      }),
      false,
      "toastNotifications/ADD_NOTIFICATION"
    );
  },

  removeNotification: (id) => {
    set(
      (state) => ({
        toastNotifications: {
          ...state.toastNotifications,
          data: state.toastNotifications.data.filter((n) => n.id !== id)
        }
      }),
      false,
      "toastNotifications/REMOVE_NOTIFICATION"
    );
  },

  clearNotifications: () => {
    set(
      (state) => ({
        toastNotifications: { ...state.toastNotifications, data: [] }
      }),
      false,
      "toastNotifications/CLEAR_ALL"
    );
  }
});
